// extracted by mini-css-extract-plugin
export default {"tip":"styles_tip__gb0pG","topic":"styles_topic__Bamu6","title":"styles_title__GUoof"};